import React from 'react';

function Smartech() {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '80vw',
            aspectRatio: '16/9',
            margin: '10vh auto'
        }}>
            <iframe
                style={{
                    width: '100%',
                    height: '100%'
                }}
                src="https://www.youtube.com/embed/YUhypzDqs0g?si=e3dnFepggY45uV_L"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
            ></iframe>
        </div>
    )
}

export default Smartech;